module.exports = __webpack_public_path__ + "static/img/attention.682a9aec.svg";